export const baseProps = {
  isOpen: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'add',
  },
}

export const defaultOrder = {
  icon: 'pi-arrow-up',
  name: 'Fecha de creación',
  value: 'created_at,asc',
}

export const months = {
  es: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
}

export const monthsOptions = {
  es: months.es.map((month, index) => ({
    label: month,
    value: index + 1,
  })),
  en: months.en.map((month, index) => ({
    label: month,
    value: index + 1,
  })),
}

export const authRoles = {
  ADMIN: 'admin',
  BUSINESS: 'business',
}

export const roles = [
  {
    label: authRoles.ADMIN,
  },
  {
    label: authRoles.BUSINESS,
  },
]
